import React, { useEffect, useState } from "react";
import Edit from "../../../Assets/img/Edit.svg";
import Delet from "../../../Assets/img/Delete.svg";
import API from "../../Service/Baseservice";
import Loading from "../../../Loading/loading";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const PrimaryInfo = () => {
    const navigate = useNavigate();
    const [infotag, setInfotag] = useState([]);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [languageId, setLanguageId] = useState(1);
    const location = useLocation();
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(9);
    const [totalPages, setTotalPages] = useState(1);
    const [showForm, setShowForm] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        background_information_data_id: "",
        language_id: "",
        background_information_id: "",
        value: "",
    });
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });
    useEffect(() => {
        fetchInfotag(false);
    }, [languageId, search, statusFilter]);

    const fetchInfotag = (shouldResetPage = false) => {
        setLoading(true);

        API.post("backgroundInformationDataList/condition", {
            language_id: languageId,
            search,
            status: statusFilter,
        })
            .then((res) => {
                const list = res?.data?.data1 || [];
                setInfotag(list);

                if (shouldResetPage) {
                    setPage(1);
                }
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };



    const filteredInfotag = infotag
        .filter((item) => item.active !== 4)
        .filter((item) => {
            const matchesSearch = item.value
                ?.toLowerCase()
                .includes(search.toLowerCase());
            const matchesStatus =
                statusFilter === ""
                    ? true
                    : statusFilter === "active"
                        ? item.status === "active"
                        : item.status === "inactive";
            return matchesSearch && matchesStatus;
        });

    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    const paginatedBlogtag = filteredInfotag.slice(start, end);

    useEffect(() => {
        setTotalPages(Math.ceil(filteredInfotag.length / rowsPerPage));
    }, [filteredInfotag, rowsPerPage]);

    console.log(
        `📑 Showing items ${start + 1}–${Math.min(
            end,
            filteredInfotag.length
        )} of ${filteredInfotag.length}`
    );

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";
        API.post("backgroundInformationDataUpdateStatus/update", {
            background_information_data_id: id,
            status: newStatus,
        })
            .then(() => fetchInfotag())
            .catch((err) => console.error("Failed to update status:", err));
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowPopup(true);
    };

    const confirmDelete = () => {
        if (!deleteId) return;
        API.post("backgroundInformationDataDelete/update", {
            background_information_data_id: deleteId,
            active: 4,
        })
            .then(() => {
                fetchInfotag();
                setShowPopup(false);
                setDeleteId(null);
            })
            .catch((err) => console.error("Failed to delete Infotag:", err));
    };

    const handleAddClick = () => {
        setIsEditing(false);
        setFormData({
            background_information_data_id: "",
            language_id: languageId,
            value: "",
            status: "active",
            createdBy: "1",
            updatedBy: "1",
        });
        setShowForm(true);
    };

   const handleEditClick = (item) => {
  setIsEditing(true);
  setFormData({
    background_information_data_id: item.background_information_data_id,
    language_id: item.language_id,
    value: item.value,
    status: item.status,
  });
  setShowForm(true);
};


    const BACKGROUND_INFO_MAP = {
        1: 1, // English
        2: 7, // French
    };


    const handleSave = () => {
        if (!formData.language_id || !formData.value) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all fields",
                type: "info",
            });
        }

        const backgroundInformationId =
            BACKGROUND_INFO_MAP[Number(formData.language_id)];

        if (!backgroundInformationId) {
            return setPopup({
                show: true,
                title: "Error",
                message: "Invalid language selected",
                type: "error",
            });
        }

        setLoading(true);

        const endpoint = isEditing
            ? "backgroundInformationDataUpdate/update"
            : "backgroundInformationDataAdd/add";

        const payload = isEditing
            ? {
                background_information_data_id:
                    formData.background_information_data_id,
                language_id: Number(formData.language_id),
                background_information_id: backgroundInformationId,
                value: formData.value,
                status: formData.status,
                active: 1,
                updatedBy: "1",
            }
            : {
                language_id: Number(formData.language_id),
                background_information_id: backgroundInformationId,
                value: formData.value,
                status: "active",
                active: 1,
                createdBy: "1",
                updatedBy: "1",
            };

        API.post(endpoint, payload)
            .then(() => {
                setPopup({
                    show: true,
                    title: "Success",
                    message: isEditing
                        ? "InfoTag updated successfully!"
                        : "InfoTag added successfully!",
                    type: "success",
                });

                fetchInfotag(true);
                setShowForm(false);
            })
            .catch(() => {
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Something went wrong",
                    type: "error",
                });
            })
            .finally(() => setLoading(false));
    };



    const handleNext = () => {
        if (page < totalPages) setPage(page + 1);
    };

    const handlePrev = () => {
        if (page > 1) setPage(page - 1);
    };
    useEffect(() => {
        if (location.state?.page) {
            setPage(location.state.page);

            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);
    return (
        <div className="category-container1">
            <div className="category-header1">
                <h2 className="category-title1">Primary Info Tag</h2>
                <button onClick={handleAddClick} className="add-btn">
                    <strong>+</strong> Add InfoTag
                </button>
            </div>

            {/* Filters */}
            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search By</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search BlogTag"
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                                localStorage.setItem("blogTagPage", 1);
                            }}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Status</label>
                    <div className="category-input-container1">
                        <select
                            className="category-input-field1"
                            value={statusFilter}
                            onChange={(e) => {
                                setStatusFilter(e.target.value);
                                setPage(1);
                                localStorage.setItem("blogTagPage", 1);
                            }}
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>
                {/* Language */}
                <div className="category-filter-block1">
                    <label>Language</label>
                    <div className="category-input-container1">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                                setPage(1);
                            }}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* BlogTag List */}
            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="category-grid2">
                        {paginatedBlogtag.length > 0 ? (
                            paginatedBlogtag.map((item) => (
                                <div className="category-card1" key={item.background_information_data_id}>
                                    <p>{item.value}</p>
                                    <div className="category-card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(item.background_information_data_id, item.status)
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>
                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-edit"
                                                onClick={() => handleEditClick(item)}
                                            />
                                            <img
                                                src={Delet}
                                                alt="Delete"
                                                className="icon-delete"
                                                onClick={() => handleDeleteClick(item.background_information_data_id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no-faq-text">No InfoTags found.</p>
                        )}
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="pagination-container">
                            <button
                                className="pagination-btn"
                                onClick={handlePrev}
                                disabled={page === 1}
                            >
                                &lt;
                            </button>

                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                                <button
                                    key={num}
                                    className={`pagination-btn ${page === num ? "active" : ""}`}
                                    onClick={() => setPage(num)}
                                >
                                    {num}
                                </button>
                            ))}

                            <button
                                className="pagination-btn"
                                onClick={handleNext}
                                disabled={page === totalPages}
                            >
                                &gt;
                            </button>
                        </div>
                    )}
                </>
            )}

            {/* Delete Popup */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Confirm Delete</h3>
                        <p>Are you sure you want to delete this BlogTag?</p>
                        <div className="popup-buttons">
                            <button className="cancel-btn " onClick={() => setShowPopup(false)}>
                                Cancel
                            </button>
                            <button className="btn delete-btn" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add/Edit Form */}
            {showForm && (
                <div className="blogtag-popup-overlay">
                    <div className={`blogtag-popup-box ${isEditing ? "edit-mode" : "add-mode"}`}>
                        <h3>{isEditing ? "Edit InfoTag" : "Add InfoTag"}</h3>
                        {!isEditing && (
                            <div className="blogtag-admin-form-group">
                                <label>Language <span className="required">*</span></label>
                                <select
                                    style={{ width: "100%" }}
                                    name="language_id"
                                    value={formData.language_id ?? ""}
                                    onChange={(e) => setFormData({ ...formData, language_id: e.target.value })}
                                >
                                    <option value="">Select Language</option>
                                    <option value="1">English</option>
                                    <option value="2">Français</option>
                                </select>
                            </div>
                        )}

                        <div className="blogtag-admin-form-group">
                            <label>Info Name <span className="required">*</span></label>
                            <input
                                type="text"
                                name="blogtag"
                                value={formData.value}
                                onChange={(e) => setFormData({ ...formData, value: e.target.value })}
                                placeholder="Enter BlogTag"
                            />
                        </div>

                        <div className="blogtag-popup-buttons">
                            <button className="cancel-btn " onClick={() => setShowForm(false)}>
                                Back
                            </button>
                            <button className="btn saves-btn" onClick={handleSave}>
                                {isEditing ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Popup */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => setPopup({ ...popup, show: false })}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PrimaryInfo;
